import { connect } from 'react-redux';

import AffidavitCertification from '../components/pages/affidavit-certification';

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
});

const mapDispatchToProps = (dispatch) => ({

});

const AffidavitCertificationConnector = connect(mapStateToProps, mapDispatchToProps)(AffidavitCertification);

export default AffidavitCertificationConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/affidavit-certification-connector.js
 **/